var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "content", class: { "single-height": !_vm.isCombo } },
      _vm._l(_vm.notificationsList, function (notificationsPerDate, index) {
        return _c(
          "div",
          { key: index, staticClass: "each-notification" },
          [
            _c("div", { staticClass: "row ml0" }, [
              _c("div", { staticClass: "col-xs-12 notification-date-css" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("formatDate")(
                        notificationsPerDate.date,
                        "YYYY-MM-DD",
                        "MMM DD, YYYY"
                      )
                    ) +
                    " "
                ),
              ]),
            ]),
            _vm._l(
              notificationsPerDate.notifications,
              function (notification, index) {
                return _c("div", { key: index, staticClass: "row ml0 mt-12" }, [
                  _c("div", { staticClass: "col-xs-1" }, [
                    notification.type == "RW" || notification.type == "UN"
                      ? _c("span", {
                          staticClass: "flag-icon flag-icon-squared",
                          class: notification.icon,
                        })
                      : notification.type == "SB"
                      ? _c("img", {
                          attrs: {
                            src: "/static/images/icons/track_plus_icon_blue.svg",
                            alt: "track-plus-icon",
                          },
                        })
                      : notification.type == "PC"
                      ? _c("img", {
                          attrs: {
                            src: "/static/images/icons/prod_classification_blue.svg",
                            alt: "prodclassification-icon",
                          },
                        })
                      : notification.type == "RP"
                      ? _c("img", {
                          attrs: {
                            src: "/static/images/icons/reg_pathway_blue.svg",
                            alt: "regpathway-icon",
                          },
                        })
                      : _c("img", {
                          attrs: {
                            src: "/static/images/icons/smartexchange_icon_blue.svg",
                            alt: "smartexchange-icon",
                          },
                        }),
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-xs-10 notification-details word-wrap" },
                    [
                      notification.type == "RW"
                        ? _c("span", [
                            _vm._v(
                              "New Regulatory update has been published for " +
                                _vm._s(notification.country_name)
                            ),
                          ])
                        : notification.type == "UN" ||
                          notification.type == "SX" ||
                          notification.type == "PC" ||
                          notification.type == "RP"
                        ? _c("span", [_vm._v(_vm._s(notification.title))])
                        : _c("span", [
                            notification.notification_type == "Project"
                              ? _c("span", [
                                  notification.project_action_type == "Export"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(notification.project_title) +
                                            " "
                                        ),
                                        notification.project_status == "Success"
                                          ? _c("span", [
                                              _vm._v("has been exported "),
                                            ])
                                          : _vm._e(),
                                        notification.project_status == "Fail"
                                          ? _c("span", [
                                              _vm._v("export failed"),
                                            ])
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                  notification.project_action_type == "Complete"
                                    ? _c("span", [
                                        _vm._v(
                                          "The " +
                                            _vm._s(notification.project_title) +
                                            " "
                                        ),
                                        notification.project_status == "Success"
                                          ? _c("span", [
                                              _vm._v("is 100% complete"),
                                            ])
                                          : _vm._e(),
                                        notification.project_status == "Fail"
                                          ? _c("span", [
                                              _vm._v("is not completed"),
                                            ])
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            notification.notification_type == "User Comment"
                              ? _c("span", [
                                  notification.comment_type == "Commented"
                                    ? _c("span", [
                                        _vm._v(
                                          "You have been mentioned in " +
                                            _vm._s(notification.project_title)
                                        ),
                                      ])
                                    : _vm._e(),
                                  notification.comment_type == "Replied"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            notification.commentator_name
                                          ) +
                                            " have been mentioned in " +
                                            _vm._s(notification.project_title)
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]),
                    ]
                  ),
                ])
              }
            ),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _c("img", {
          staticClass: "notification_icon",
          attrs: { src: "/static/images/icons/notification_blue.svg" },
        }),
        _c("span", [_vm._v("Notifications")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }